import { axiosInstance } from "./utils/axiosInterceptor";

export const NOTIFICATION_CACHE_KEY = "/notifications";

export interface Notification {
  id: number;
  organization_id: number;
  recipient_id: number;
  sender_id: number;
  type: string;
  entity_type: string;
  entity_id: number;
  workout_id: number | null;
  message: string;
  read_at: string | null;
  created_at: string;
  sender_username: string | null;
  sender_first_name: string | null;
  sender_last_name: string | null;
}

export async function getNotifications(page = 1, size = 20): Promise<Notification[]> {
  const response = await axiosInstance.get(NOTIFICATION_CACHE_KEY, {
    params: { page, size },
  });
  return response.data;
}

export async function getUnreadCount(): Promise<{ count: number }> {
  const response = await axiosInstance.get(`${NOTIFICATION_CACHE_KEY}/unread-count`);
  return response.data;
}

export async function markAsRead(id: number): Promise<void> {
  await axiosInstance.post(`${NOTIFICATION_CACHE_KEY}/${id}/read`);
}

export async function markAllRead(): Promise<void> {
  await axiosInstance.post(`${NOTIFICATION_CACHE_KEY}/read-all`);
}
